import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, addDoc, deleteDoc, setDoc, query, orderBy, limit, startAfter, endBefore, onSnapshot } from "firebase/firestore";
import { getStorage, ref, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";
import { requestEndPoint } from '@/store/Api'

Vue.use(VueAxios, Axios);

const db = getFirestore();

const storageInstance = getStorage()
const storage = ref(storageInstance, "pushNotificationImages/");

export default {
  state: {
    pushNotifications: [],
    unsubscribePushNotifications: null,
    pushNotificationsByGroupList: [],

  },
  mutations: {
    SET_PUSH_NOTIFICATIONS(state, pushNotifications) {
      state.pushNotifications = pushNotifications;
    },
    SET_UNSUBSCRIBE_PUSH_NOTIFICATIONS(state, unsubscribe) {
      state.unsubscribePushNotifications = unsubscribe;
    },
    GO_UNSUBSCRIBE_PUSH_NOTIFICATIONS(state) {
      state.unsubscribePushNotifications();
    },
    SET_PUSH_NOTIFICATIONS_BY_GROUP(state, pushNotificationsByGroupList) {
      state.pushNotificationsByGroupList = pushNotificationsByGroupList;
    },
  },
  actions: {
    GetNotifications({ commit }) {
      return new Promise(async (resolve, reject) => {
        const notificationsRef = collection(db, "pushNotificationsList");
        const querySnapshot = await getDocs(notificationsRef);
        let notificationsList = [];
        querySnapshot.forEach((doc) => {
          let notification = doc.data();
          notification.id = doc.id;
          notificationsList.push(notification);
        });
        commit("SET_PUSH_NOTIFICATIONS", notificationsList);
        resolve(notificationsList);
      });
    },
    GetPushNotificationsPaginatedFirstPage({ commit, getters }, itemsPerPage) {
      return new Promise(async (resolve, reject) => {

        if (getters.getPushNotifications.length > 0) {
          commit("GO_UNSUBSCRIBE_PUSH_NOTIFICATIONS");
        }
        const notificationsRef = collection(db, "pushNotificationsList");
        const q = query(notificationsRef, orderBy('title'), limit(itemsPerPage));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          let notificationsList = [];
          querySnapshot.forEach((doc) => {
            let notification = doc.data()
            notificationsList.push(notification);
          });
          commit("SET_PUSH_NOTIFICATIONS", notificationsList);
          resolve(notificationsList);
        },
          (error) => {
            reject(error);
          }
        );
        commit("SET_UNSUBSCRIBE_PUSH_NOTIFICATIONS", unsubscribe);
      });
    },
    GetPushNotificationsNextPage({ commit, getters }, itemsPerPage) {
      return new Promise(async (resolve, reject) => {
        console.log('getters.getPushNotifications', getters.getPushNotifications);
        commit("GO_UNSUBSCRIBE_PUSH_NOTIFICATIONS");
        const notificationsRef = collection(db, "pushNotificationsList");
        const q = query(notificationsRef, orderBy('title'), startAfter(getters.getPushNotifications[getters.getPushNotifications.length - 1].title), limit(itemsPerPage));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          let notificationsList = [];
          querySnapshot.forEach((doc) => {
            let notification = doc.data()
            notificationsList.push(notification);
          });
          console.log(querySnapshot);
          if (notificationsList.length > 0) {
            commit("SET_PUSH_NOTIFICATIONS", notificationsList);
          }
          resolve(notificationsList);
        },
          (error) => {
            reject(error);
          }
        );
        commit("SET_UNSUBSCRIBE_PUSH_NOTIFICATIONS", unsubscribe);
      });
    },
    GetPushNotificationsPrevPage({ commit, getters }, itemsPerPage) {
      return new Promise(async (resolve, reject) => {
        commit("GO_UNSUBSCRIBE_PUSH_NOTIFICATIONS");
        const notificationsRef = collection(db, "pushNotificationsList");
                 const q = query(notificationsRef, orderBy('title', 'desc'), startAfter(getters.getPushNotifications[0].title), limit(itemsPerPage));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          let notificationsList = [];
          querySnapshot.forEach((doc) => {
            let notification = doc.data()
            notificationsList.push(notification);
          });
          commit("SET_PUSH_NOTIFICATIONS", notificationsList);
          resolve(notificationsList);
        },
          (error) => {
            reject(error);
          }
        );
        commit("SET_UNSUBSCRIBE_PUSH_NOTIFICATIONS", unsubscribe);
      });
    },
    GoUnsuscribeGetPushNotifications({ commit }) {
      commit("GO_UNSUBSCRIBE_PUSH_NOTIFICATIONS");
    },
    async UploadImage({ }, imageBase) {
      try {
        let random = uuidv4();
        let storageRef = ref(storageInstance, `pushNotificationImages/${random}`);
        await uploadString(storageRef, imageBase, "data_url");
        const downloadURL = await getDownloadURL(storageRef);
        return downloadURL;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async CreateNotification({ }, notification) {
      try {
        const notificationData = {
          ...notification,
          createdAt: new Date(),
          updatedAt: new Date(),
        }
        const ref = await addDoc(collection(db, "pushNotificationsList"), notificationData);
        return ref.id;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async SendNotificationBySegment({ }, notification) {
      try {
        const res = await Vue.axios.post("https://us-central1-maxfit-app.cloudfunctions.net/sendNotificationBySegment", notification, { headers: null })
        return res.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async UpdateNotification({ }, notification) {
      try {
        notification.updatedAt = new Date();
        await updateDoc(doc(db, "pushNotificationsList", notification.id), notification);
        return notification.id;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    DeleteNotification({ }, notification) {
      return new Promise(async (resolve, reject) => {
        await deleteDoc(doc(db, "pushNotificationsList", notification.id))
          .then((res) => {
            resolve(notification.id);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    SendNotification({ }, notification) {
      return new Promise((resolve, reject) => {
        Vue.axios
          .post(requestEndPoint.sendMassiveNotification, notification)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      })
    },
    SendUserNotification({ }, notification) {
      return new Promise((resolve, reject) => {
        Vue.axios
          .post(requestEndPoint.sendUserNotification, notification)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      })

    },
    GetPushNotificationsByGroup({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          const querySnapshot = await getDocs(collection(db, "pushNotificationsByGroupList"));
          const notificationsPushByGroupList = []
          querySnapshot.forEach(async (doc) => {
            let notificationPushByGroup = doc.data()
            notificationsPushByGroupList.push(notificationPushByGroup)
          })
          commit('SET_PUSH_NOTIFICATIONS_BY_GROUP', notificationsPushByGroupList)
          resolve(notificationsPushByGroupList)
        } catch (error) {
          reject(error)
        }
      })
    },
    SendUserNotificationByGroup({ }, notification) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await Vue.axios.post(requestEndPoint.sendNotificationToTopic, notification, { headers: null })
          resolve(res.data);
        } catch (error) {
          reject(error)
          console.error(error);
        }


        // Vue.axios
        //   .post(requestEndPoint.sendNotificationToTopic, testVar)
        //   .then((response) => {
        //     console.log('responsee', response);
        //     resolve(response.data);
        //   })
        //   .catch((error) => {
        //     reject(error);
        //   });
      })

    },
  },
  getters: {
    getPushNotifications(state) {
      return state.pushNotifications;
    },
    getPushNotificationsByGroupList(state) {
      return state.pushNotificationsByGroupList;
    },
  },
};
